import { useRoute } from '#imports'
import { ref, shallowReactive } from 'vue'

import type { SearchConfiguration } from '@backmarket/http-api/src/api-specs-search-reco/search/searchConfiguration'
import { getInitialFiltersDict } from '@backmarket/nuxt-layer-recommendation/filtering/getInitialFiltersDict'

import { useSearchQueryParam } from '~/composables/useSearchQueryParam/useSearchQueryParam'

function parseQueryValues(
  raw: string | null | Array<string | null> | undefined,
): string[] {
  if (!raw) return []

  return (Array.isArray(raw) ? raw : [raw]).filter(
    (v): v is string => typeof v === 'string' && v.length > 0,
  )
}

export function useSearchState(
  searchConfig: SearchConfiguration,
  openFacets: string[] = [],
) {
  const route = useRoute()
  const query = useSearchQueryParam()

  const openFilterKey = openFacets.find((key) => route.query[key] != null)
  const openFilterRaw = openFilterKey ? route.query[openFilterKey] : undefined
  const openFilterValues = parseQueryValues(openFilterRaw)

  const filters = shallowReactive<Record<string, string[]>>({
    ...getInitialFiltersDict(searchConfig.facets),
    ...(openFilterKey && openFilterValues.length > 0
      ? { [openFilterKey]: openFilterValues }
      : {}),
  })
  const sort = ref(searchConfig.indexes.active.name)
  const page = ref(Number.parseInt(route.query.p?.toString() || '1', 10) || 1)
  const price = ref<[number, number]>()
  const isResetting = ref(false)

  function reset() {
    isResetting.value = true
    Object.assign(filters, getInitialFiltersDict(searchConfig.facets))
    sort.value = searchConfig.indexes.active.name
    page.value = 1
    price.value = undefined
    isResetting.value = false
  }

  return {
    query,
    filters,
    sort,
    page,
    price,
    reset,
    isResetting,
  }
}
